<template>
  <StepLayout
    :keyword="keyword"
    title="知りたいことを選んでください"
    :current-step="1"
    :show-back-link="false"
    @back="handleBack"
  >
    <OptionList
      v-model="model"
      :options="categoryOptions"
      aria-label="知りたいことの選択"
      @select="handleSelect"
    />

    <template #skip>
      <SkipLink label="質問をスキップ" @click="handleSkip" />
    </template>
  </StepLayout>
</template>

<script setup lang="ts">
import StepLayout from './StepLayoutInline.vue';
import OptionList from './OptionList.vue';
import SkipLink from './SkipLink.vue';
import type { CategoryOption } from '../../types';
import { categoryOptions } from '../../questions';

defineProps<{
  keyword: string;
}>();

const model = defineModel<CategoryOption | null>({ default: null });

const emit = defineEmits<{
  next: [];
  back: [];
  skip: [];
}>();

const handleSelect = () => {
  emit('next');
};

const handleBack = () => {
  emit('back');
};

const handleSkip = () => {
  emit('skip');
};
</script>

<style lang="scss" scoped>
// StepLayout provides all common styling
</style>
